import { Container } from 'unstated';
import { isEmpty, isNumeric } from 'validator';

import { validateEmptyValue } from '../../../helpers/Validations/validateEmptyValue';

export interface IVoucherGroupDetailState {
  voucherGroup: GQL.IVoucherGroup;
  errors: IValidationErrors;
  selectedDeliveryMethodIds: Array<string>;
  customerGroupsIds: Array<string>;
  includedProductIds: Array<string>;
  giftId?: string;
}

export interface IVoucherGroupDetailStateProps {
  voucherGroup: GQL.IVoucherGroup;
}

export interface IValidationErrors {
  title: string | undefined;
  source: string | undefined;
  type: string | undefined;
  amount: string | undefined;
}

export class StateContainer extends Container<IVoucherGroupDetailState> {

  constructor(props: IVoucherGroupDetailStateProps) {
    super();

    const voucherGroup = props.voucherGroup && props.voucherGroup.id ? props.voucherGroup : ({} as any);

    this.state = {
      voucherGroup: {
        ...{
          applyToDiscountedGoods: false,
          type: 'percent',
          source: 'price',
          active: true,
        },
        ...voucherGroup, 
      },
      errors: {} as IValidationErrors,
      selectedDeliveryMethodIds: (voucherGroup.freeShipping || []).map(p => p.id),
      customerGroupsIds: (voucherGroup.customerGroups || []).map(g => g.id),
      includedProductIds: voucherGroup.includedProducts || [],
      giftId: voucherGroup.giftId || null,
    };

    this.preValidate();
  }

  public async onChange(key: string, val: any) {
    const voucherGroup = { ...this.state.voucherGroup };
    await this.setState({ voucherGroup: { ...voucherGroup, [key]: val } });
  }

  public async preValidate() { }

  public async validate(): Promise<IValidationErrors> {
    const { voucherGroup } = this.state;
    const errors = { ...this.state.errors };

    const message = 'This field is required';

    const validateEmpty = (input: string) => {
      if (input == undefined || isEmpty(input)) {
        return message;
      } else {
        return undefined;
      }
    };

    const validateNumeric = (input: string | number) => {
      if (input == undefined || !isNumeric('' + input)) {
        if (input == '0') {
          return undefined;
        }
        return message;
      }

      return undefined;
    };

    errors.title = validateEmpty(voucherGroup.title);
    errors.source = validateEmpty(voucherGroup.source);
    errors.type = validateEmpty(voucherGroup.type);
    errors.amount = validateNumeric(voucherGroup.amount);

    await this.setState({ errors });
    return errors;
  }

  private async validateField(fieldName: string) {
    const { voucherGroup } = this.state;

    const message = validateEmptyValue(voucherGroup[fieldName], true);

    await this.setState({
      errors: { ...this.state.errors, [fieldName]: message }
    });
  }

  public async getVoucherGroup() {
    return {
      ...this.state.voucherGroup, 
      deliveryMethodsIds: this.state.selectedDeliveryMethodIds
    };
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VoucherGroups/VoucherGroupDetail/StateContainer.ts